function highlightSearchText(element, searchTerm) {
  if (!searchTerm || searchTerm.trim().length < 2) return;
  
  const normalizedTerm = searchTerm.trim();
  
  try {
    removeExistingHighlights(element);
    
    const cleanHTML = element.innerHTML;
    const textContent = element.textContent || element.innerText || '';
    
    if (textContent.toLowerCase().includes(normalizedTerm.toLowerCase())) {
      const escapedTerm = normalizedTerm.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      
      const regex = new RegExp(`(${escapedTerm})`, 'gi');
      
      const highlightedHTML = highlightTextInHTML(cleanHTML, regex);
      
      if (highlightedHTML !== cleanHTML) {
        element.innerHTML = highlightedHTML;
      }
    }
  } catch (error) {
    console.warn('Error highlighting text:', error);
  }
}

function removeExistingHighlights(element) {
  const highlights = element.querySelectorAll('.faq-search-highlight');
  highlights.forEach(highlight => {
    const parent = highlight.parentNode;
    parent.replaceChild(document.createTextNode(highlight.textContent), highlight);
    parent.normalize();
  });
}

function highlightTextInHTML(html, regex) {
  return html.replace(regex, function(match, p1, offset, string) {
    const beforeMatch = string.substring(0, offset);
    const lastOpenTag = beforeMatch.lastIndexOf('<');
    const lastCloseTag = beforeMatch.lastIndexOf('>');
    
    if (lastOpenTag > lastCloseTag) {
      return match;
    }
    
    return '<span class="faq-search-highlight">' + p1 + '</span>';
  });
}
window.faqHighlightText = highlightSearchText;